const DEFAULT_LOCALE = 'en-US';

const normalizeNumericString = (value) => {
    if (typeof value !== 'string') return '';
    return value.replace(/,/g, '').replace(/[^0-9.-]/g, '').trim();
};

export const toNumberPrice = (value) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }

    if (typeof value === 'string') {
        const parsed = Number.parseFloat(normalizeNumericString(value));
        return Number.isFinite(parsed) ? parsed : null;
    }

    return null;
};

export const formatProductPrice = (priceValue, currencyCode,roundingEnabled, locale = DEFAULT_LOCALE) => {
    if (!currencyCode) {
        return priceValue ?? '';
    }

    let numericPrice = toNumberPrice(priceValue);
    const rate = parseFloat(window.__VOICE_SEARCH_CONFIG__.currencyRate || 1);
    numericPrice = numericPrice * rate
    if (roundingEnabled === 1) {
        numericPrice = Math.ceil(numericPrice);
    }
    if (numericPrice === null) {
        return priceValue ?? '';
    }

    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'code'
        }).format(numericPrice);
    } catch (_) {
        return `${currencyCode} ${numericPrice.toFixed(2)}`;
    }
};

